var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtworkInformationImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85742 26.5512H10.9289V28.965H4.85742V26.5512ZM4.85742 21.7236H10.9289V24.1374H4.85742V21.7236Z",
    fill: "url(#paint0_linear_564_25960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3571 35H2.42857C1.09286 35 0 33.9138 0 32.5862V19.3103C0 17.9828 1.09286 16.8966 2.42857 16.8966H13.3571C14.6929 16.8966 15.7857 17.9828 15.7857 19.3103V32.5862C15.7857 33.9138 14.6929 35 13.3571 35ZM2.42857 19.3103V32.5862H13.3571V19.3103H2.42857ZM20.6429 1.2069H30.3571V3.62069H20.6429V1.2069ZM24.2857 6.03448H34V8.44828H24.2857V6.03448ZM24.2857 10.8621H34V13.2759H24.2857V10.8621ZM20.6429 15.6897H30.3571V18.1034H20.6429V15.6897ZM24.2857 20.5172H34V22.931H24.2857V20.5172ZM12.1429 0L10.4429 1.68966L13.6 4.82759H2.42857C1.09286 4.82759 0 5.91379 0 7.24138V13.2759H2.42857V7.24138H13.6L10.4429 10.3793L12.1429 12.069L18.2143 6.03448L12.1429 0Z",
    fill: "url(#paint1_linear_564_25960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_564_25960",
    x1: 7.89314,
    y1: 21.7236,
    x2: 7.89314,
    y2: 28.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_564_25960",
    x1: 17,
    y1: 0,
    x2: 17,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtworkInformationImg);
export default __webpack_public_path__ + "static/media/Artwork_information_img.4606f4189bb88d43a971eae1bc8a5cde.svg";
export { ForwardRef as ReactComponent };